<button type="submit" [class.saved]="saved" [class.dirty]="dirty" [disabled]="disabled">
  <span>{{saveText}}</span>
  <span>{{savedText}}</span>
</button>
